import fileSaver from '../../../../helpers/download.helper'
import { AxiosService } from '../../../../services/axios.service'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { ticketsSalesReportConstants } from './tickets-sales-report.constants'

const isAdmin = () => location.pathname.includes('/admin/passagens-vendidas')

const exportData = params => dispatch => {
	dispatch({
		type: ticketsSalesReportConstants.EXPORT_DATA
	})
	dispatch(SiteCreators.showLoading())

	const url = isAdmin()
		? 'admin/bilhete/relatorios/exportar'
		: 'parceiro-planalto/relatorios/exportar-vendas'

	AxiosService.get(url, {
		responseType: 'blob',
		params: params
	})
		.then(({ data }) => {
			dispatch(SiteCreators.hideLoading())
			dispatch(downloadData(data))
		})
		.catch(() => dispatch(SiteCreators.hideLoading()))
}

const downloadData = downloadData => async dispatch => {
	dispatch({
		type: ticketsSalesReportConstants.DOWNLOAD_DATA
	})

	const fileName = isAdmin() ? 'passagens-vendidas.csv' : 'vendas-planalto.csv'

	await fileSaver(downloadData, fileName)
}

export const ticketsSalesReportActions = { exportData }
